<template>
    <el-dialog title="绘制答题卡进度" :visible.sync="dialogVisible"  width="30%" @before-close="closeCheck" @close="handClose" :close-on-click-modal="false">
        <div style="display: flex; align-items: center; margin-left: 30%;">  
            <h2 style="font-size: 15px;">绘制进度： 当前排在</h2>   
            <h1 style="color: #0e70fb; font-size: 20px; margin: 0 5px;">{{ num }}</h1>  
            <h2 style="font-size: 15px;"> / {{ totalCount }} 位</h2>  
        </div>  
        <!-- <h3>绘制答题卡： 当前排在 {{ num }} / {{ totalCount }} 位</h3> -->
        <div style="margin-bottom: 20px; margin-bottom: 10px;">
            <div style="text-align: center; margin-top: 20px;">
                <el-progress :percentage="percentage" type="circle" :color="colors"></el-progress>
            </div>
            <span style="color: red; font-size: 12px;margin-top: 25px;" v-show="isTag">数据量大，打包速度较慢，请稍等</span>
            <span style="color: #0e70fb; font-size: 12px;margin-top: 20px;" v-show="!isTag && percentage == 100">绘制答题卡完成，请关闭绘制窗口</span>
            <span style="color: #0e70fb; font-size: 12px;margin-top: 20px;" v-show="!isTag && percentage != 100">考试数据有{{ resultCount }}条数据，请稍等</span>
        </div>


        <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="handClose" v-show="isDraw">关 闭</el-button>
            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
        </span> -->
    </el-dialog>
   
</template>
  
  <script>
  import * as simpleApi from "request/simple";
  // 组件逻辑
  export default {
    name: 'remarkProcess',
    props: {
    },
    data() {
      return {
        examId: null,
        totalCount: 0,
        num: 0,
        dialogVisible: false,
        // colors: [
        //   {color: '#f56c6c', percentage: 20},
        //   {color: '#e6a23c', percentage: 40},
        //   {color: '#5cb87a', percentage: 60},
        //   {color: '#0e70fb', percentage: 80},
        //   {color: '#0e70fb', percentage: 100}
        // ],
        percentage: 0,
        isDraw: false,
        timer: null, // 定时器引用  
        data: null, // 接口返回的数据  
        error: null, // 错误信息  
        timerDraw: null, // 定时器引用  
        isTag: false,
        // 进度条默认1000 毫秒 间隔
        customInterval: 1000, 
        resultCount: 0
      }
    },
    computed: {
    },
    created() {
        // this.loading()
    },
    mounted() {
    },
    methods: {
        loading(examId){
            this.examId = examId
            let param = { controllerName: 'exam', methodName: '/downScantronQueue', param: { examId: examId }};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                if (code == 0) {
                    
                    if(data == null || data == undefined || data == []){
                        // 排序不存在时说明已经绘制完成
                        this.$message({ type: 'success', message: '答题卡绘制完成！'});
                    }else{
                        this.dialogVisible = true
                        // 判断考试号是否正在绘制答题卡
                        this.totalCount = data[0].totalCount
                        this.num = data[0].score
                        this.resultCount = data[0].resultCount
                        this.intervalRules()
                        // 启动进度条绘制
                        if(this.num == 1) {
                            this.intervalRules()
                            this.startCounting()
                        }
                        // 启动定时器
                        this.startTimer()
                    }
                    
                }
                
            });
        },
        openVisible(){
            this.dialogVisible = true
        },
        // 查看是否是当前排序第一名，如果是则不允许关闭窗口
        closeCheck(done){
            let close = true
            // 排序第一且进度不为100
            if(this.num == 1 && this.percentage != 100) close = false
            if(close){
                done(); // 调用 done() 函数，关闭对话框  
            }else{
                this.$message({ type: 'warning', message: '当前答题卡正在绘制，请勿关闭窗口'});
            }
        },
        handClose(){
            // 查看是否是当前排序第一名，如果是则不允许关闭窗口
            let close = true
            // 排序第一且进度不为100
            if(this.num == 1 && this.percentage != 100) close = false
            if(close){
                this.isTag = false
                this.isDraw = false
                this.percentage = 0
                this.beforeDestroy()
                this.beforeDestroyCounting()
                this.dialogVisible = false
            }else{
                this.dialogVisible = true
                this.$message({ type: 'warning', message: '当前答题卡正在绘制，请勿关闭窗口'});
            }
            
        },
        // 启动定时请求  
        startTimer() {  
            // 清除先前的定时器，避免重复启动  
            this.stopTimer();  
            // 开始新的定时器  
            this.timer = setInterval(() => {  
                this.fetchData(); // 请求数据  
            }, 30000); // 每30秒请求一次  
        },  
        
        // 停止定时请求  
        stopTimer() {  
            if (this.timer) {  
                clearInterval(this.timer);  
                this.timer = null; // 清空定时器引用  
            }  
        },  
        
        // 请求数据的方法  
        fetchData() {  
            // 请求排序进度
            this.getCount()
        },  
        beforeDestroy() {  
            // 组件销毁前清除定时器  
            this.stopTimer();  
        },  
        // 获取排序
        getCount(){
            let param = { controllerName: 'exam', methodName: '/downScantronQueue', param: { examId: this.examId }};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                if (code == 0) {
                    if(data == null || data == undefined || data ==[]){
       
                        this.totalCount = 0
                        this.num = 0
                        this.percentage = 100
                        this.$message({ type: 'success', message: '答题卡绘制完成！'});
                        // 当前考试绘制完成
                        // this.handClose()
                        this.isTag = false
                        // 关闭计时器
                        this.beforeDestroy()
                        this.beforeDestroyCounting()
                    }else{
                       
                        this.totalCount = data[0].totalCount
                        this.num = data[0].score
                        this.resultCount = data[0].resultCount
                        // 排序第一且暂未启动进度条计时器时，启动进度条绘制 
                        if(this.num == 1 && this.timerDraw == null && this.percentage == 0) {
                            this.intervalRules()
                            this.startCounting()
                        }
                    }
                    
                }
                
            });
        },
        // 开始计数的方法  
        startCounting() {  
            // 如果计时器已经存在，则先清除它，确保只启动一个  
            this.stopCounting();  
            this.timerDraw = setInterval(() => {  
                this.percentage += 1; // 每 2 秒自增 1  
                if(this.percentage == 99) {
                    // 停止进度条绘制，弹窗显示
                    this.isTag = true
                    this.beforeDestroyCounting()
                }
            }, 1000); 
            
        },  
        
        // 停止计数的方法  
        stopCounting() {  
            if (this.timerDraw) {  
                clearInterval(this.timerDraw); // 清除定时器  
                this.timerDraw = null; // 清空定时器引用  
            }  
        },  
        beforeDestroyCounting() {  
            // 组件销毁前清除定时器，以避免内存泄漏  
            this.stopCounting();  
        },  
        // 计算进度条时间间隔
        intervalRules(){
            if(this.resultCount > 100){
                // 超出一百条后，按比例分配到99
                let num = Math.floor(this.resultCount / 100)
                this.customInterval = this.resultCount % 100 == 0 ? num * 1000 : (num + 1) *1000 
            }
        }
    }
  }
  </script>
  
  <style scoped>

  </style>